///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.short_dated = abcsetup.short_dated || {};
abcsetup.short_dated.opportunities = abcsetup.short_dated.opportunities || {};
abcsetup.short_dated.opportunities.create = abcsetup.short_dated.opportunities.create || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////

abcsetup.short_dated.opportunities.create = {
    /**
     * _jquery.fieldLib
     *      Fields have been init - this is the callback
     */
    fieldsInit: function () {
        // TODO: split aparent the common lib between opportunities + responses
        abcsetup.short_dated_opportunity.common.bindFields();
    },

    init: function () {
        // If All Suppliers checkbox is clicked, adjust requirements for Org Selection
        $('#all_suppliers').on('change', function(e) {
            if ($(this).is(":checked")) {
                $('#suppliers').prop('required', false);
                $('#suppliers').prop('disabled', true);
                $('#suppliers-group').removeClass('required');
            } else {
                $('#suppliers').prop('required', true);
                $('#suppliers').prop('disabled', false);
                $('#suppliers-group').addClass('required');
            }
        });

        // Vendors are being imported from an excel document
        $(document).on("click", "#supplier-upload-btn", function () {
            abcsetup.blockUI(true);
            $('#supplierUploadModal').modal('hide');
            abcsetup.excel.readFile($("#supplierUploadInput")[0], function(importData) {
                axios.post('/api/short_dated_opportunity/get_supplier_orgs', { vendor_ids: importData })
                    .then((response) => {
                        if (response.data) {
                            var supplier_ids_imported_count = response.data.supplier_ids_imported_count;
                            var org_ids_matched_count = response.data.org_ids_matched_count;
                            var org_ids_matched = response.data.org_ids_matched;
                            var org_ids_not_matched = response.data.org_ids_not_matched
                            var org_ids_not_matched_count = response.data.org_ids_not_matched_count

                            if (org_ids_not_matched_count > 0 ) {
                                abcsetup.alerts.show('Import Results', '<b>' + org_ids_matched_count  + '</b> of <b>' + supplier_ids_imported_count + '</b> suppliers found! <br> <br><b>' + org_ids_not_matched_count + '</b> Not found: <br>' + org_ids_not_matched);
                            } else {
                                abcsetup.alerts.show('Import Results', '<b>' + org_ids_matched_count  + '</b> of <b>' + supplier_ids_imported_count + '</b> suppliers found!');
                            }

                            $('#suppliers').val(org_ids_matched).trigger('change');
                        }
                    })
                    .catch((error) => {
                        abcsetup.unblockUI();
                    });
            });
            abcsetup.unblockUI();
        });

        // clear the supplier dropdown selections
        $(document).on("click", "#supplier-refresh", function () {
            abcsetup.short_dated.opportunities.create.clearSupplierDropdown();
        });
    },

    clearSupplierDropdown: function() {
        $('#suppliers').val([]).trigger('change');
        $('#matched-message').html('').hide();
    }
}
